const currencyConfig = {
  USD: {
    symbol: '$',
    plans: {
      basic: {
        price: 49,
        link: 'https://buy.stripe.com/fZueV64ypc3b3Cy8RF9sk01',
      },
      professional: {
        price: 76,
        link: 'https://buy.stripe.com/fZu7sEaWN1oxgpk0l99sk02',
      },
      enterprise: {
        price: 99,
        link: 'https://buy.stripe.com/14A8wI2qhd7f3Cyd7V9sk03',
      },
    },
  }
};

export const getPricingPlans = () => {
  const config = currencyConfig.USD;
  const { symbol, plans } = config;

  return [
    {
      name: 'Basic',
      price: `${symbol}${plans.basic.price}`,
      popular: false,
      link: plans.basic.link,
      features: {
        interviewTime: '45 minutes',
        feedbackTime: '15 minutes',
        extras: [
          'Questions and discussion',
          'Feedback report',
          'Advice on improvement',
          'Email support'
        ],
      },
    },
    {
      name: 'Professional',
      price: `${symbol}${plans.professional.price}`,
      popular: true,
      link: plans.professional.link,
      features: {
        interviewTime: '75 minutes',
        feedbackTime: '15 minutes',
        extras: [
          'Questions and discussion',
          'Advice on improvement',
          'Feedback report',
          'Live coding exercise',
          'Resume/CV tips',
        ],
      },
    },
    {
      name: 'Enterprise',
      price: `${symbol}${plans.enterprise.price}`,
      popular: false,
      link: plans.enterprise.link,
      features: {
        interviewTime: '90 minutes',
        feedbackTime: '30 minutes',
        extras: [
          'Questions and discussion',
          'Advice on improvement',
          'Feedback report',
          'Comprehensive Live coding exercises',
          'Resume/CV tips',
          'LinkedIn profile review',
        ],
      },
    },
  ];
};

export const pricingPlans = getPricingPlans();
